(function ($) {
    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial) {
        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return compareBottom <= viewBottom && compareTop >= viewTop;
    };
})(jQuery);

function lazyVideo() {
    const videoWraps = document.querySelectorAll(".video_container");
    const videoStateMap = new Map();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting && !videoStateMap.get(target)) {
                videoStateMap.set(target, true);

                // console.log("play");

                $(target).find("video")[0].play();
            }
        });
    });

    videoWraps.forEach((videoWrap) => {
        videoStateMap.set(videoWrap, false);
        observer.observe(videoWrap);
    });
}

var flyin = function () {
    var win = $(window);

    var allMods = $("body.flyin .flyin");

    allMods.each(function (i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass("already-visible");
        }
    });

    win.scroll(function (event) {
        allMods.each(function (i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("come-in");
            }
        });
    });
};

var adjustAccordion = function (width) {
    $(".accordion .row .accordion-headers").each(function (index) {
        $(this).attr("data-index", index);
        $(this).next(".accordion-content").attr("data-index", index);
    });

    if (width < 768) {
        $(".accordion .row").each(function (index) {
            $(".accordion-headers, .accordion-content").each(function (index) {
                $(this).alterClass("order-*", "").addClass("order-${index}");
            });
        });
    } else {
        $(".accordion-headers").alterClass("order-*", "");
        $(".accordion-content").alterClass("order-*", "").addClass("order-last");
    }
};

$(function () {
    adjustAccordion($(window).width());
    $(".accordion-headers").click(function () {
        var index = $(this).data("index");
        $(".accordion-headers").removeClass("active");
        $(this).addClass("active");
        $(".accordion-content").slideUp(300);
        $('.accordion-content[data-index="' + index + '"')
            .delay(300)
            .slideDown(300);
        // $('.accordion-content').fadeOut(300);
        // $('.accordion-content[data-index="' + index + '"').delay(290).fadeIn(300);
    });

    $('.accordion-headers[data-index="0"').addClass("active");
    $('.accordion-content[data-index="0"').addClass("active").show();

    $(window).resize(function () {
        var width = $(window).width();
        adjustAccordion(width);
    });
});

function logo(params) {
    if (!$("body").hasClass("bg-secondary") && window.innerWidth >= "992") {
        var m = $("#main");
        var m_top = m.offset().top;

        var kr = $("#logo #k, #logo #r");
        var l = $("#logo #l");

        var kr_height = document.getElementById("k").getBoundingClientRect().height;
        var l_height = document.getElementById("l").getBoundingClientRect().height;

        var kr_top = kr.offset().top;
        var kr_bot = kr.offset().top + kr_height;

        var l_top = l.offset().top;
        var l_bot = l.offset().top + l_height;

        var diff_kr = kr_bot - m_top;
        var diff_l = l_bot - m_top;

        var l1 = $("#menu #l1");
        var l1_height = document.getElementById("l1").getBoundingClientRect().height;
        var l1_top = l1.offset().top;
        var l1_bot = l1.offset().top + l1_height;
        var diff_l1 = l1_bot - m_top;

        var l2 = $("#menu #l2");
        var l2_height = document.getElementById("l2").getBoundingClientRect().height;
        var l2_top = l2.offset().top;
        var l2_bot = l2.offset().top + l2_height;
        var diff_l2 = l2_bot - m_top;

        var l3 = $("#menu #l3");
        var l3_height = document.getElementById("l3").getBoundingClientRect().height;
        var l3_top = l3.offset().top;
        var l3_bot = l3.offset().top + l3_height;
        var diff_l3 = l3_bot - m_top;

        if (diff_kr > 0 && diff_kr < kr_height) {
            var diff_kr_p = 100 - Math.floor((diff_kr / kr_height) * 100);
            $("#logo #grad_01 .color-stop-2, #logo #grad_01 .color-stop-3").attr("offset", diff_kr_p + "%");
        } else if (diff_kr > kr_height) {
            $("#logo #grad_01 .color-stop-2, #logo #grad_01 .color-stop-3").attr("offset", "0");
        } else if (diff_kr < 0) {
            $("#logo #grad_01 .color-stop-2, #logo #grad_01 .color-stop-3").attr("offset", "100%");
        }

        if (diff_l > 0 && diff_l < l_height) {
            var diff_l_p = 100 - Math.floor((diff_l / l_height) * 100);
            $("#logo #grad_02 .color-stop-2, #logo #grad_02 .color-stop-3").attr("offset", diff_l_p + "%");
        } else if (diff_l > l_height) {
            $("#logo #grad_02 .color-stop-2, #logo #grad_02 .color-stop-3").attr("offset", "0");
        } else if (diff_l < 0) {
            $("#logo #grad_02 .color-stop-2, #logo #grad_02 .color-stop-3").attr("offset", "100%");
        }

        if (diff_l1 > 0 && diff_l1 < l1_height) {
            var diff_l1_p = 100 - Math.floor((diff_l1 / l1_height) * 100);
            $("#menu #grad_03 .color-stop-2, #menu #grad_03 .color-stop-3").attr("offset", diff_l1_p + "%");
        } else if (diff_l1 > l1_height) {
            $("#menu #grad_03 .color-stop-2, #menu #grad_03 .color-stop-3").attr("offset", "0");
        } else if (diff_l1 < 0) {
            $("#menu #grad_03 .color-stop-2, #menu #grad_03 .color-stop-3").attr("offset", "100%");
        }

        if (diff_l2 > 0 && diff_l2 < l2_height) {
            var diff_l2_p = 100 - Math.floor((diff_l2 / l2_height) * 100);
            $("#menu #grad_04 .color-stop-2, #menu #grad_04 .color-stop-3").attr("offset", diff_l2_p + "%");
        } else if (diff_l2 > l2_height) {
            $("#menu #grad_04 .color-stop-2, #menu #grad_04 .color-stop-3").attr("offset", "0");
        } else if (diff_l2 < 0) {
            $("#menu #grad_04 .color-stop-2, #menu #grad_04 .color-stop-3").attr("offset", "100%");
        }

        if (diff_l3 > 0 && diff_l3 < l3_height) {
            var diff_l3_p = 100 - Math.floor((diff_l3 / l3_height) * 100);
            $("#menu #grad_05 .color-stop-2, #menu #grad_05 .color-stop-3").attr("offset", diff_l3_p + "%");
        } else if (diff_l3 > l3_height) {
            $("#menu #grad_05 .color-stop-2, #menu #grad_05 .color-stop-3").attr("offset", "0");
        } else if (diff_l3 < 0) {
            $("#menu #grad_05 .color-stop-2, #menu #grad_05 .color-stop-3").attr("offset", "100%");
        }
    }
}

var slider = function () {
    var time = 2;
    var $bar, $slick, isPause, tick, percentTime;

    $slick = $(".slider");
    $slick.slick({
        arrows: true,
        speed: 1200,
        adaptiveHeight: false,
        fade: true,
        prevArrow: '<a data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"></a>',
        nextArrow: '<a data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"></a>',
    });

    $bar = $(".slider-progress .progress");

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 30);
    }

    function interval() {
        if (isPause === false) {
            percentTime += 1 / (time + 0.1);
            $bar.css({
                width: percentTime + "%",
            });
            if (percentTime >= 100) {
                $slick.slick("slickNext");
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $bar.css({
            width: 0 + "%",
        });
        clearTimeout(tick);
    }

    startProgressbar();

    $(".slick-next, .slick-prev").click(function () {
        startProgressbar();
    });
};

$(function () {
    $("#nl2go_form").on("submit", function (e) {
        e.preventDefault();

        var recipient = $(this)
            .serializeArray()
            .map(
                function (x) {
                    this[x.name] = x.value;
                    return this;
                }.bind({})
            )[0];

        //Daten an Newsletter2Go senden
        n2g(
            "subscribe:send",
            {
                recipient: recipient,
            },
            function (data) {
                if (data.status == 201) {
                    //Ausgabe der Statusmeldung anstelle des Formulars
                    $("#form").html(
                        "<h2 class='text-center'>Vielen Dank für die Anmeldung.</h2><p class='text-center'>Wir haben eine E-Mail mit einem Bestätigungslink zugeschickt. Nur noch ein Klick und interessante KR-News kommen regelmäßig an.</p>"
                    );
                } else if (data.status == 200) {
                    if (data.value[0].result.error.recipients.invalid.length) {
                        $("#form").html("<h2 class='text-center'>Ihre E-Mail Adresse ist nicht valide.</h2>");
                    }

                    //Ausgabe der Statusmeldung anstelle des Formulars
                    $("#form").html("<h2 class='text-center'>Du bist bereits angemeldet!</h2>");
                } else {
                    //Ausgabe der Statusmeldung anstelle des Formulars
                    $("#form").html("<h2 class='text-center'>Es ist ein Fehler aufgetreten!</h2>");
                }
            },
            function (data) {
                //Ausgabe der Statusmeldung anstelle des Formulars
                $("#form").html("<h2 class='text-center'>Es ist ein Fehler aufgetreten!</h2>");
            }
        );
    });
});

(function ($) {
    $(document).ready(function () {
        // console.log("ready");

        // alert(screen.pixelDepth);

        $(".ref_nav .ce_text").wrapInner('<div class="background d-flex align-items-center"><div class="inner"></div></div>');
        //.addClass('d-flex align-items-center')

        logo();
        lazyVideo();

        $(document).scroll(function () {
            logo();
        });

        $("#menu a").click(function (ev) {
            ev.preventDefault();

            $("#mainnav").slideToggle({
                easing: "swing",
                start: function () {
                    $(this).css({
                        display: "flex",
                    });
                    $("#logo, #menu").toggleClass("menu-open");
                },
            });
        });

        slider();
        flyin();

        $(".vino-slider").slick({
            infinite: true,
            dots: true,
            arrows: false,
            appendDots: $(".vino-dots"),
        });

        $(".vino-next").on("click", function (e) {
            e.preventDefault();
            $(".vino-slider").slick("slickNext");
        });

        $(".vino-prev").on("click", function (e) {
            e.preventDefault();
            $(".vino-slider").slick("slickPrev");
        });
    });
})(jQuery);
